import { com } from '@eidu/form'
import EntityWithLabelAndRelated from '../domain/entity/EntityWithLabelAndRelated'
import Link from '../domain/entity/Link'
import assetRuntimeLinkKey = com.eidu.sharedlib.entity.assetRuntimeLinkKey

export const getRuntimeIdFromEntity = (entity: EntityWithLabelAndRelated): string | undefined =>
  entity.entity.links.asJsReadonlyMapView().get(assetRuntimeLinkKey)

export const getEntityLinkFromRuntimeId = (runtimeId: string | null): Link => ({
  key: assetRuntimeLinkKey,
  value: runtimeId,
})
